import { BreadcrumbsColor, BreadcrumbsVariant } from "./types";

export const filledColorScheme: Record<
  BreadcrumbsColor,
  { bgClassName: string; linkClassName: string; disabledClassName: string }
> = {
  [BreadcrumbsColor.Light]: {
    bgClassName: "bg-light",
    linkClassName: "text-primary font-bold",
    disabledClassName: "text-dark",
  },
  [BreadcrumbsColor.Neutral]: {
    bgClassName: "bg-neutral",
    linkClassName: "text-primary font-bold",
    disabledClassName: "text-dark",
  },
  [BreadcrumbsColor.Dark]: {
    bgClassName: "bg-dark",
    linkClassName: "text-primary font-extrabold",
    disabledClassName: "text-light font-thin",
  },
  [BreadcrumbsColor.Primary]: {
    bgClassName: "bg-primary",
    linkClassName: "text-light font-semibold",
    disabledClassName: "text-light font-thin",
  },
};

export const transparentColorScheme: Record<
  BreadcrumbsColor,
  { linkClassName: string; disabledClassName: string }
> = {
  [BreadcrumbsColor.Light]: {
    linkClassName: "text-light font-bold",
    disabledClassName: "text-light",
  },
  [BreadcrumbsColor.Neutral]: {
    linkClassName: "text-neutral font-bold",
    disabledClassName: "text-neutral",
  },
  [BreadcrumbsColor.Dark]: {
    linkClassName: "text-dark font-extrabold",
    disabledClassName: "text-dark font-thin",
  },
  [BreadcrumbsColor.Primary]: {
    linkClassName: "text-primary font-semibold",
    disabledClassName: "font-thin",
  },
};

export const colorSchemes: Record<
  BreadcrumbsVariant,
  Record<
    BreadcrumbsColor,
    { bgClassName?: string; linkClassName: string; disabledClassName: string }
  >
> = {
  [BreadcrumbsVariant.Transparent]: transparentColorScheme,
  [BreadcrumbsVariant.Filled]: filledColorScheme,
};
